import { render, staticRenderFns } from "./CustomerSite.vue?vue&type=template&id=22828404&"
import script from "./CustomerSite.vue?vue&type=script&lang=js&"
export * from "./CustomerSite.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports